module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-37.2918b737.svg";